// extracted by mini-css-extract-plugin
module.exports = {"fundingPageDiv":"StandardPage_fundingPageDiv__Ae74z","fundingPageDateDiv":"StandardPage_fundingPageDateDiv__6DvEM"};